<template>
  <div class="trip_wrapper white_bg">
    <!-- <template v-if="model_info">
      <div class="model_info item_block">
        <div class="report_section_basic_info_car_pic">
            <img :src="model_info.model_img" />
          </div>
          <CarInfoTable 
          :car_info="model_info"
          />
      </div>
    </template> -->
  
    <div class="item_block">
      <div class="chart_container" v-if="model_info">
        <NodeName
          :node_name="l1_node_name"
        />
        <LineChartComponent 
          :node_id="l1_node_id"
          :models="[
            {
              'model_id':model_info.model_id,
              'report_id':model_info.report_id,
              'model_name':model_info.model_name
            }
          ]"
          @handel="l1_click"
        />
      </div>
      <div class="chart_container chart_container2" v-if="l2_node_id">
        <NodeName
          :node_name="l1_node_name+'-'+l2_node_name"
        />
        <LineChartComponent 
          :node_id="l2_node_id"
          :models="[
            {
              'model_id':model_info.model_id,
              'report_id':model_info.report_id,
              'model_name':model_info.model_name
            }
          ]"
          @handel="l2_click"
          @loadEnd="goAnthor('.chart_container2')"
        />
      </div>
      <div class="chart_container chart_container3" v-if="l3_node_id">
        <NodeName
          :node_name="l1_node_name+'-'+l2_node_name+'-'+l3_node_name"
        />
        <LineChartComponent 
          :node_id="l3_node_id"
          :models="[
            {
              'model_id':model_info.model_id,
              'report_id':model_info.report_id,
              'model_name':model_info.model_name
            }
          ]"
          @handel="l3_click"
          @loadEnd="goAnthor('.chart_container3')"
        />
      </div>
      <template v-if="model_info">
        
        <div class="table_container" v-show="tree_table_data">
        <NodeName
          :node_name="l1_node_name+'-'+l2_node_name+'-'+l3_node_name+'-'+l4_node_name"
        />
            <tree-table-base
              v-loading="tree_table_loading"
              :data_type="1"
              :model_list="[
                {
                  'model_id':model_info.model_id,
                  'report_id':model_info.report_id,
                  'model_name':model_info.model_name
                }
              ]"
              :data="tree_table_data"
            >
            </tree-table-base>
        </div>
      </template>
      
    </div>
  </div>
</template>
 
<script>
import {
  ref
} from "vue"
import {
  useRouter
} from "vue-router"
import {
  getCarSummaryData,
  getCarScore
} from "@/api"
// import CarInfoTable from "@/components/common/views/carInfoTable.vue";
import LineChartComponent from "@/components/echarts/BarChartComponent.vue";
import TreeTableBase from "@/components/common/views/treeTable/TreeTableBase.vue"
import NodeName from "@/components/common/views/NodeName.vue";
export default {
  components:{
    // CarInfoTable,
    LineChartComponent,
    TreeTableBase,
    NodeName
  },
  setup(){
    const router = useRouter();
    const { model_id } = router.currentRoute.value.query;
    const query_model_id = ref(model_id);

    const model_info = ref(null);
    // 获取车型信息
    const getCarInfo = () => {
      getCarSummaryData({
        model_id: query_model_id.value,
        get_base: 1,
      }).then((res) => {
        model_info.value = res.data;
      });
    };
    getCarInfo();
    // 旅途一级
    const l1_node_id = ref(3);
    const l2_node_id = ref(null);
    const l3_node_id = ref(null);
    const l1_node_name = ref("旅途场景");
    const l2_node_name = ref("");
    const l3_node_name = ref("");
    const l4_node_name = ref("");
    const tree_table_data = ref(null);
    const tree_table_loading = ref(false);
    
    const l1_click = (node)=>{
      l2_node_id.value = node.node_id;
      l2_node_name.value = node.node_name;
      l3_node_id.value = null;
      tree_table_data.value = null;
    }
    // 旅途二级
    const l2_click = (node)=>{
      l3_node_id.value = node.node_id;
      l3_node_name.value = node.node_name;
      tree_table_data.value = null;
    }
    // 旅途三级
    const l3_click = (node)=>{
      l4_node_name.value = node.node_name;
      getTableData(node)
    }
    // 旅途子节点表格
    const getTableData = (node)=>{
      let query_info_list = [{
        model_id:model_info.value.model_id,
        report_id:model_info.value.report_id,
        node_id:node.node_id,
        need_own:1
      }]
      let promise_list = query_info_list.map(item=>{
        return new Promise((resolve,reject)=>{
          getCarScore(item)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
        })
      })
       Promise.all(promise_list).then((res_list) => {
        tree_table_data.value = res_list; 
        tree_table_loading.value = false;
        goAnthor(".table_container")
      })
    }

    const goAnthor = (selector)=>{
      setTimeout(() => {
        const height = document.querySelector(selector).offsetTop;
        const container = document.querySelector('.el-main');
        container.scrollTo({
          top:height-150,
          behavior: 'smooth'
        })
      }, 100);
    };

    return {
      model_info,
      l1_node_id,
      l1_node_name,
      l1_click,
      l2_node_id,
      l2_node_name,
      l2_click,
      l3_node_id,
      l3_node_name,
      l3_click,
      l4_node_name,
      tree_table_data,
      tree_table_loading,
      goAnthor
    }
  }
}
</script>

<style lang="less" scoped>
.item_block{
  width: 1200px;
  background: #fff;
  margin-bottom: 20px;
  padding-bottom: 45px;
}
.model_info{
  width: 1200px;
  background: #ffffff;
  border-radius: 4px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  .report_section_basic_info_car_pic{
    width:180px;
    height:98px;
    flex-shrink: 0;
    img{
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
.chart_container{
  padding: 37px 45px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.table_container{
  width: 1090px;
  margin: 45px auto 0;
}
</style>